import { selectFromUserSubscription } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import UserQuery from '../queries/user/UserQuery';
import TeamMemberQuery from '../queries/team/TeamMemberQuery';
import teamMemberDeletedHandler from './handlers/account/teamMemberDeletedHandler';

const selector = selectFromUserSubscription()
  .userInviteCreatedDto(b => b.user(UserQuery))
  .teamMemberCreatedDto(b => b.member(TeamMemberQuery))
  .teamMemberUpdatedDto(b => b.member(TeamMemberQuery))
  .teamMemberDeletedDto(b => b.userUuid)
  .toString();

export default (): SubscriptionHandler => ({
  name: 'UserSubscription',
  selector,
  events: new Map(Object.entries({
    TeamMemberDeletedDto: [teamMemberDeletedHandler],
  })),
  onError(error: Error) {
    console.error(error);
  },
});
